// src/router/index.js

import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/pinia/authStore'
import { storeToRefs } from 'pinia'

import HomePage from '@/views/HomePage.vue'
import HelpPage from '@/views/HelpPage.vue'
import ProjectManagement from '@/views/ProjectManagement.vue'
import ProjectManagementJobDetail from '@/views/ProjectManagementJobDetail.vue'
import DSAReport from '@/views/DSAReport.vue'

// Employee Insights components
import EmployeeInsightsLandingPage from '@/EmployeeInsightsComponents/EmployeeInsightsLandingPage.vue'
import AllStaffInsights from '@/EmployeeInsightsComponents/AllStaff.vue'
import IndividualStaffInsights from '@/EmployeeInsightsComponents/IndividualStaff.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/help',
    name: 'Help',
    component: HelpPage
  },
  {
    path: '/project-management',
    name: 'ProjectManagement',
    component: ProjectManagement,
    meta: { fixedWorkArea: true }
  },
  {
    path: '/project-management/job/:jobId',
    name: 'ProjectManagementJobDetail',
    component: ProjectManagementJobDetail,
    props: true,
    meta: { fixedWorkArea: true }
  },
  {
    path: '/dsa-report',
    name: 'DSAReport',
    component: DSAReport
  },
  {
    path: '/employee-dashboard/:staffId',
    meta: { fixedWorkArea: true },
    component: EmployeeInsightsLandingPage,
    children: [
      {
        path: '',
        name: 'EmployeeDashboard',
        component: IndividualStaffInsights,
        props: true
      }
    ]
  },
  {
    path: '/employee-insights',
    meta: { fixedWorkArea: true },
    component: EmployeeInsightsLandingPage,
    children: [
      {
        path: '',
        name: 'AllStaffInsights',
        component: AllStaffInsights
      },
      {
        path: ':staffId',
        name: 'IndividualStaffInsights',
        component: IndividualStaffInsights,
        props: true
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

let authChecked = false
// Global auth guard
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const { isAuthenticated } = storeToRefs(authStore)

  const publicRoutes = ['Home', 'Help']

  if (!authChecked) {
    await authStore.checkAuthStatus()
    authChecked = true
  }

  if (!isAuthenticated.value && !publicRoutes.includes(to.name)) {
    next({ name: 'Home' }) // or redirect to a Login page if you have one
  } else {
    next()
  }
})

export default router
